module.exports = __webpack_public_path__ + "static/media/three_lady_01.b0028980.png";